module.exports = __webpack_public_path__ + "img/rankingHeader.3b7c0131.jpg";